import { Card, CardBody, Flex, Text } from '@backstage/ui';

import type { TeamHistoryKpisDto } from '@internal/scorecards-common';

interface HistoryKpiCardsProps {
  kpis: TeamHistoryKpisDto;
}

export const HistoryKpiCards = ({ kpis }: HistoryKpiCardsProps) => {
  return (
    <Flex gap="4">
      <Card grow={1}>
        <CardBody>
          <Flex direction="column" gap="2">
            <Text as="p" variant="body-small" weight="bold">
              FAILING NOW
            </Text>
            <Text as="p">
              <Text
                as="span"
                variant="title-medium"
                style={{
                  color:
                    kpis.failingChecks > 0 ? 'var(--zf-sc-fail)' : undefined,
                }}
              >
                {kpis.failingChecks}
              </Text>
              <Text as="span" variant="body-large" color="secondary">
                {' '}
                checks
              </Text>
            </Text>
            <Text as="p" variant="body-small" color="secondary">
              {kpis.failingProjects} project
              {kpis.failingProjects !== 1 ? 's' : ''} affected
            </Text>
          </Flex>
        </CardBody>
      </Card>
      <Card grow={1}>
        <CardBody>
          <Flex direction="column" gap="2">
            <Text as="p" variant="body-small" weight="bold">
              FIXED
            </Text>
            <Text as="p">
              <Text
                as="span"
                variant="title-medium"
                style={{
                  color: kpis.fixed > 0 ? 'var(--zf-sc-pass)' : undefined,
                }}
              >
                {kpis.fixed}
              </Text>
              <Text as="span" variant="body-large" color="secondary">
                {' '}
                checks
              </Text>
            </Text>
            <Text as="p" variant="body-small" color="secondary">
              went back to passing in this period
            </Text>
          </Flex>
        </CardBody>
      </Card>
      <Card grow={1}>
        <CardBody>
          <Flex direction="column" gap="2">
            <Text as="p" variant="body-small" weight="bold">
              LONGEST OPEN
            </Text>
            {kpis.longestOpen ? (
              <>
                <Text as="p">
                  <Text as="span" variant="title-medium">
                    {kpis.longestOpen.days}
                  </Text>
                  <Text as="span" variant="body-large" color="secondary">
                    {' '}
                    days
                  </Text>
                </Text>
                <Text as="p" variant="body-small" color="secondary">
                  {kpis.longestOpen.check} · {kpis.longestOpen.project}
                </Text>
              </>
            ) : (
              <>
                <Text as="p" variant="title-medium">
                  -
                </Text>
                <Text as="p" variant="body-small" color="secondary">
                  No open failures
                </Text>
              </>
            )}
          </Flex>
        </CardBody>
      </Card>
    </Flex>
  );
};
